import { useMemo, useState } from 'react'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import { Avatar, Button, Skeleton, Stack, Typography } from '@mui/material'
import ApartmentIcon from '@mui/icons-material/Apartment'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#7C7CCF',
    padding: 0,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    borderRadius: 0,
}))

interface LabelFocusProps {
    discoverData: any
}

const LabelsFocus = ({ discoverData }: LabelFocusProps) => {
    var [currentIndex, setCurrentIndex] = useState(0) 

    const labelStats = useMemo(() => {
        if (discoverData === null)
            return []

        let dayRanks = discoverData?.rankings
        var producers_ids: any = []
        var allProducers: any = []
        for (const rank of dayRanks) {
            if (rank.track.album?.record_label && rank.track.album.record_label._id) {
                if (![...allProducers].map((alb: any) => alb._id).includes(rank.track.album.record_label._id)) 
                    allProducers.push(rank.track.album.record_label)
                producers_ids[rank.track.album.record_label._id] = (producers_ids[rank.track.album.record_label._id] || 0) + 1                    
            }
        }

        var items = Object.keys(producers_ids).map(function(key) { return [key, producers_ids[key]] })
        items.sort(function(a, b) { return b[1] - a[1] })
        return allProducers.sort((a: any, b: any) => items.map((item: any) => item[0]).indexOf(a._id) - items.map((item: any) => item[0]).indexOf(b._id)).map((prod: any, i: number) => {
            return {
                ...prod,
                topTrackCount: items[i][1]
            }
        })
    }, [discoverData])

    const showNextLabel = () => {
        if (currentIndex + 1 === labelStats.length || currentIndex > labelStats.length) {
            setCurrentIndex(0)
        } else {
            setCurrentIndex(currentIndex + 1)
        }
    }

    const showPreviousLabel = () => {
        if (currentIndex - 1 === -1 || currentIndex < 0) {
            setCurrentIndex(labelStats.length - 1)
        } else {
            setCurrentIndex(currentIndex - 1)
        }
    }

    return labelStats && labelStats.length > 0
        ? 
            <Item sx={{
                height: {xs: '30%', md: '20%', lg: '20%'},
                borderRadius: '16px',
                overflow: 'hidden',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundImage: labelStats[currentIndex].medias.filter((media: any) => media.ref_type === "logo").length > 0 ? 'url(' + labelStats[currentIndex].medias.filter((media: any) => media.ref_type === "logo")[0].content + ')'  : ''
                }}>
                <Stack direction={'row'} sx={{height: '100%', backdropFilter: 'blur(15px)', backgroundColor: '#ffffff60'}}>
                    <Button onClick={() => showPreviousLabel()}><NavigateBeforeIcon /></Button>
                    <Stack alignItems={'center'} direction={'row'} sx={{width: '100%'}}>
                         { labelStats[currentIndex].medias.filter((media: any) => media.ref_type === "logo").length > 0 ? <Avatar 
                            variant='square'
                            src={''}
                            sx={{
                                p: 2,
                                backgroundColor: labelStats[currentIndex].medias.filter((media: any) => media.ref_type === "logo").length > 0 ? '#08082F20' : '#08082F',
                                borderRadius: '16px',
                                m: 2, 
                                width: '2vh', 
                                height: '2vh', 
                                '& img': { objectFit: 'contain'}
                            }}
                            >
                                <ApartmentIcon />
                        </Avatar> : '' }
                        <Typography sx={{textAlign: 'center', width: '100%'}}>
                            <b>{labelStats[currentIndex].name.replaceAll('/', ' / ')}</b> <br></br>- <b>{labelStats[currentIndex].topTrackCount}</b> Tracks dans le top 100 -
                        </Typography> 
                    </Stack>
                   <Button onClick={() => showNextLabel()}><NavigateNextIcon /></Button>
                </Stack>
            </Item>
        : 
            <Skeleton variant="rectangular" width={'100%'} height={'25%'} sx={{bgcolor: '#000000E8'}}/>

}

export default LabelsFocus